import { useContext, useEffect } from 'react'
import { useTypedSelector } from 'src/State/RootReducer'
import { useShopAdmin, useShopLogin } from 'src/Libs/shop/hooks'
import { SHOP_ADMIN_PERMISSION } from 'src/Libs/shop/consts'
import { updateShopAccess } from 'src/State/Shop/ShopAction'
import { useDispatch } from 'react-redux'
import { AuthContext } from '@e3dc-react/shell/Libs/authentication'

/**
 * @description This hook is used to login to the shop framework
 * @returns {void}
 */
const useShopFrameworkLogin = (): void => {
  const { shopLogin } = useShopLogin()
  const { fetchShopAdminAccess } = useShopAdmin()
  const { authToken } = useContext(AuthContext)
  const shopPermission = useTypedSelector(state => state.user.company?.shopPermission)
  const userLevel = useTypedSelector(state => state.user.userData?.level)
  const isShopAdmin = userLevel?.startsWith(SHOP_ADMIN_PERMISSION)
  const dispatch = useDispatch()

  useEffect(() => {
    const canAccessShopAsNormalUser = userLevel !== undefined && !isShopAdmin
    const loginToShop = async (portalToken: string): Promise<void> => {
      if (isShopAdmin) {
        const result = await fetchShopAdminAccess()

        if (result?.hasPermission === false && userLevel === 'E3DC_SERVICE') {
          await shopLogin(portalToken)
        }

        if (result?.hasPermission) {
          dispatch(updateShopAccess(result?.hasPermission ?? false))
        }
      }

      if (canAccessShopAsNormalUser && shopPermission) {
        await shopLogin(portalToken)
      }
    }

    if (authToken) {
      loginToShop(authToken)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userLevel, shopPermission])
}

export default useShopFrameworkLogin
